import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import { FilterOperation } from "../../../../components/Grid/dataProvider";
import { FormattedDate } from "react-intl";
import { showDegrees } from "../../CroUtils";
import { ReleasedType, StatementAppealsFilterEnum, StatementAppealsFilterType } from "../../enum";

export default (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "10%",
    },
    {
      field: "birthDate",
      label: "Datum narození",
      type: ColumnType.DATE,
      width: "15%",
    },
    {
      field: "wpVisibility",
      label: "Viditelnost",
      type: ColumnType.ENUM,
      width: "15%",
    },
    {
      field: "created",
      label: "Datum zápisu",
      type: ColumnType.DATE,
      width: "15%",
    },
    {
      field: "dateOfEnd",
      label: "Datum zápisu ukončení",
      type: ColumnType.DATE,
      width: "15%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const OfficialsLegitimate = (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "5%",
    },
    {
      field: "birthDate",
      label: "Datum narození",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "concatenatedWorkingPositionDates",
      label: "Období",
      type: ColumnType.TEXT,
      width: "15%",
      sortable: false,
    },
    {
      field: "active",
      label: "Aktivní",
      type: ColumnType.CHECK,
      width: "5%",
    },
    {
      field: "concatenatedOvms",
      displayField: "concatenatedOvms",
      label: "Podpůrný orgán",
      type: ColumnType.TEXT,
      width: "15%",
      exportValue: (row) => row.concatenatedOvms
    },
    {
      field: "workingFrom",
      label: "Období od",
      type: ColumnType.DATE,
      display: false,
      fromDate: true,
    },
    {
      field: "workingTo",
      label: "Období do",
      type: ColumnType.DATE,
      display: false,
      toDate: true,
    },
  ];

  const filters = [
    {
      field: "firstName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "lastName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositions",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
  ];

  return <CommonGrid {...props} columns={columns} filters={filters} />;
};

export const OfficialsActive = (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "6%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "7%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "5%",
    },
    {
      field: "birthDate",
      label: "Datum narození",
      type: ColumnType.DATE,
      width: "8%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "8%",
    },
    {
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "14%",
    },
    {
      field: "concatenatedWorkingPositionDates",
      label: "Období",
      type: ColumnType.TEXT,
      width: "15%",
      sortable: false,
    },
    {
      field: "databox",
      label: "Datová schránka",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      field: "wpVisibility",
      label: "Viditelnost",
      type: ColumnType.TEXT,
      width: "7%",
    },
    {
      field: "active",
      label: "Aktivní",
      type: ColumnType.CHECK,
      width: "5%",
    },
    {
      field: "checked",
      label: "Zkontrolován",
      type: ColumnType.YESNO,
      width: "5%",
    },
    // {
    //   field: 'created',
    //   label: 'Datum zápisu',
    //   type: ColumnType.DATE,
    //   width: '7%'
    // },
    // {
    //   field: 'dateOfEnd',
    //   label: 'Datum zápisu ukončení',
    //   type: ColumnType.DATE,
    //   width: '7%'
    // },
    {
      field: "appealDate",
      label: "Byla odeslána výzva",
      type: ColumnType.JSX,
      jsx: (row) => (
        <div>
          {row.appealDate && <FormattedDate value={row.appealDate} />}
          {!row.appealDate && <div>NE</div>}
        </div>
      ),
      width: "7%",
    },
    {
      field: "concatenatedOvms",
      displayField: "concatenatedOvms",
      label: "Podpůrný orgán",
      type: ColumnType.TEXT,
      width: "8%",
      exportValue: (row) => row.concatenatedOvms
    },
    {
      field: "workingFrom",
      label: "Období od",
      type: ColumnType.DATE,
      display: false,
      fromDate: true,
    },
    {
      field: "workingTo",
      label: "Období do",
      type: ColumnType.DATE,
      display: false,
      toDate: true,
    },
    {
      field: "workingPositions.released",
      label: "Uvolněnost",
      type: ColumnType.ENUM,
      enum: ReleasedType,
      filterItems: ReleasedType,
      display: false,
    },
    {
      field: "appeals.type",
      label: "Zaslání výzvy",
      type: ColumnType.ENUM,
      enum: StatementAppealsFilterEnum,
      filterItems: StatementAppealsFilterEnum,
      filterBy: { type: ColumnType.ENUM, values:
        Object.keys(StatementAppealsFilterType).reduce((acc, key) => {
          const field = key === "NONE" ? "appeals" : "appeals.type";
          const operation = key === "NONE" ? FilterOperation.IS_NULL : FilterOperation.EQ;
          acc[key] = { field: field, operation: operation, value: key };
          return acc;
        }, {})
      },
      display: false
    }
  ];

  const filters = [
    {
      field: "firstName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "lastName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositions",
      operation: FilterOperation.CONTAINS,
      value: "",
    }
  ];

  return <CommonGrid {...props} columns={columns} filters={filters} />;
};

export const OfficialsPublic = (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "10%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "concatenatedWorkingPositionDates",
      label: "Období",
      type: ColumnType.TEXT,
      width: "115%",
      sortable: false,
    },
    {
      field: "concatenatedOvms",
      displayField: "concatenatedOvms",
      label: "Podpůrný orgán",
      type: ColumnType.TEXT,
      width: "15%",
      exportValue: (row) => row.concatenatedOvms
    },
    {
      field: "workingFrom",
      label: "Období od",
      type: ColumnType.DATE,
      display: false,
      fromDate: true,
    },
    {
      field: "workingTo",
      label: "Období do",
      type: ColumnType.DATE,
      display: false,
      toDate: true,
    },
  ];

  const filters = [
    {
      field: "firstName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "lastName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositions",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    // {
    //   field: 'workingFrom',
    //   operation: FilterOperation.GTE,
    //   value: ''
    // },
  ];

  const pageSizeItems = [
    { id: 10, label: "10" },
    { id: 20, label: "20" },
    { id: 50, label: "50" },
    { id: 100, label: "100" },
  ];

  return (
    <CommonGrid
      {...props}
      columns={columns}
      filters={filters}
      pageSizeItems={pageSizeItems}
    />
  );
};

export const OfficialsInInitiative = (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "20%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "5%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "concatenatedWorkingPositionDates",
      label: "Období",
      type: ColumnType.TEXT,
      width: "15%",
    },
  ];

  const filters = [
    {
      field: "firstName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "lastName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositions",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
  ];

  return <CommonGrid {...props} columns={columns} filters={filters} />;
};

export const OfficialsActiveOvm = (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "birthDate",
      label: "Datum narození",
      type: ColumnType.DATE,
      width: "8%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "18%",
    },
    {
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "16%",
    },
    {
      field: "concatenatedWorkingPositionDates",
      label: "Období",
      type: ColumnType.TEXT,
      width: "14%",
      sortable: false,
    },
    {
      field: "active",
      label: "Aktivní",
      type: ColumnType.CHECK,
      width: "6%",
    },
    // {
    //   field: 'created',
    //   label: 'Datum zápisu zahájení',
    //   type: ColumnType.DATE,
    //   width: '8%'
    // },
    // {
    //   field: 'dateOfEnd',
    //   label: 'Datum zápisu ukončení',
    //   type: ColumnType.DATE,
    //   width: '8%'
    // },
    {
      field: "lastStatementDate",
      label: <span>Datum podání posledního<br />oznámení</span>,
      type: ColumnType.DATE,
      width: "8%",
    },
    {
      field: "concatenatedOvms",
      label: "Podpůrný orgán",
      type: ColumnType.TEXT,
      width: "10%",
      exportValue: (row) => row.concatenatedOvms
    },
    {
      field: "workingFrom",
      label: "Období od",
      type: ColumnType.DATE,
      display: false,
      fromDate: true,
    },
    {
      field: "workingTo",
      label: "Období do",
      type: ColumnType.DATE,
      display: false,
      toDate: true,
    },
  ];

  const filters = [
    {
      field: "firstName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "lastName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositions",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
  ];

  return <CommonGrid {...props} columns={columns} filters={filters} />;
};

export const OfficialsInRequest = (props) => {
  const columns = [
    {
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "17%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "5%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "20%",
    },
    {
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "18%",
    },
    {
      field: "wpVisibility",
      label: "Viditelnost",
      type: ColumnType.TEXT,
      width: "10%",
      filterItems: [
        { id: "REQUEST", label: "Na žádost" },
        { id: "SECRET", label: "Tajný" },
      ],
      filterBy: {
        type: ColumnType.ENUM,
        values: {
          REQUEST: { field: "wpVisibility", operation: FilterOperation.CONTAINS, value: '"na žádost"' },
          SECRET: { field: "wpVisibility", operation: FilterOperation.CONTAINS, value: "tajný" },
        },
      },
    },
    {
      field: "concatenatedWorkingPositionDates",
      label: "Období",
      type: ColumnType.TEXT,
      width: "18%",
    },
  ];

  const filters = [
    {
      field: "firstName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "lastName",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
    {
      field: "concatenatedWorkingPositions",
      operation: FilterOperation.CONTAINS,
      value: "",
    },
  ];

  return <CommonGrid {...props} columns={columns} filters={filters} />;
};
